
// You can write more code here

/* START OF COMPILED CODE */

/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class NPCGuidanceArrow extends Phaser.GameObjects.Container {

	constructor(scene: Phaser.Scene, x?: number, y?: number) {
		super(scene, x ?? 0, y ?? 0);

		// npcArrow
		const npcArrow = scene.add.image(0, 0, "npc_guidance_arrow");
		npcArrow.scaleX = 2;
		npcArrow.scaleY = 2;
		npcArrow.setOrigin(0.5, 1);
		this.add(npcArrow);

		/* START-USER-CTR-CODE */
		// Write your code here.
		/* END-USER-CTR-CODE */
	}

	/* START-USER-CODE */

	// Write your code here.

	/* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
